import styled, { css } from 'styled-components';

import { useCustomTheme } from '../../styles';


type RootProps = {
	width?: number;
	height?: number;
	color?: string;
};

const Root = styled.i<RootProps>`
	display: inline-flex;
	font-size: 0;
	line-height: 1;
	width: auto;
	height: auto;

	${p => css`
		& svg {
			width: ${p.width}px !important;
			height: ${p.height}px !important;
		}
	`}

	${p => {
		if (!p.color) return ``;
		const [theme] = useCustomTheme(p);
		const colorByNamesMap = {
			'white': theme.color.whitePrimary,
			'danger': theme.color.dangerPrimary,
			'black': theme.color.blackPrimary,
			'primary': theme.color.accentPrimary,
			'muted': theme.color.blackSecondary
		};

		return css`
			color: ${colorByNamesMap[p.color]}
		`
	}}
`;

export {
	Root,
};
